import React from 'react';
import { PropTypes } from 'prop-types';
import UtilityTable from '../components/UtilityTable';

export const Utilities = ({ pageFilter }) => <UtilityTable pageFilter={pageFilter} />;

Utilities.propTypes = {
  pageFilter: PropTypes.string,
};

export default Utilities;
